export interface ICancelSelectFormatTree {
  requestTreeNodeSelectStatus(): void;
  cancelSelectFormatTree(): void;
}

export function instanceOfICancelSelectFormatTree(instance: any): instance is ICancelSelectFormatTree {
  return instance
    && (instance.requestTreeNodeSelectStatus !== undefined)
    && (instance.cancelSelectFormatTree !== undefined);
}
